module.exports = __webpack_public_path__ + "media/images/disbursement_channels/bank_card-7a644a1d4978b23ec7d7db199ce45196.svg";